export default "__VITE_ASSET__58c27f6d__"